<template>
    <div :class="['replies_outer', depth === 0 ? 'indent' : '']" :data-depth="depth">
        <div class="c-comments__comment">
            <img class="c-comments__img" :src="reply.user_avatar" :alt="reply.user_name + ' comment'">
            <div class="c-comments__content">
                <div class="c-comments__user">
                    <p><a :href="'/u/' + reply.user_name">{{ reply.user_name }}</a></p>
                    <p>{{ parent_username ? parent_username : first_username }}</p>
                    <p>{{ reply.comment_created}}</p>
                </div>
                <p class="u-m-t1 u-m-b3 c-comments__text"  v-html="reply.comment_text">
                    {{ reply.comment_text }}
                </p>
                <p class="u-m-t1 u-m-b3" v-if="reply.comment_image != ''">
                    <img :src="reply.comment_image" :alt="reply.user_name + 'comment'" />
                </p>
                <div class="c-comments__cta">
                    <p><a href="#" @click.prevent="commentReply">Reply</a></p>
                    <div @click="saveCommentLike(reply.comment_id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" :class="{'liked': userLiked > 0 }">
                            <defs>
                                <path id="icon-likes-a" d="M17,5.18420563 C17,2.3210388 14.6586159,0 11.7703517,0 C10.5319425,0 9.39596622,0.428901458 8.5,1.14203776 C7.60403378,0.428901458 6.46805748,0 5.2296483,0 C2.34138409,0 0,2.3210388 0,5.18420563 C0,6.53676412 0.526736417,7.76419979 1.38241523,8.68721952 L7.21466028,15.4226081 C7.2502332,15.4684936 7.28794907,15.5126796 7.32866507,15.5541039 C7.60574814,15.8321782 7.98012101,16 8.39413841,16 C8.8081558,16 9.18252868,15.8321782 9.45232573,15.5617515 C9.49925627,15.5122547 9.52582882,15.4831514 9.5509013,15.4525611 L15.6250851,8.68721952 C16.4732636,7.76419979 17,6.53676412 17,5.18420563 Z"></path>
                            </defs>
                            <g class="like" fill="none" fill-rule="evenodd">
                                <path stroke="#888" d="M16.5,5.18420563 C16.5,2.59816271 14.3834456,0.5 11.7703517,0.5 C10.6797153,0.5 9.64690314,0.868217049 8.81137834,1.53324554 L8.5,1.78108435 L8.18862166,1.53324554 C7.35309686,0.868217049 6.32028473,0.5 5.2296483,0.5 C2.61655436,0.5 0.5,2.59816271 0.5,5.18420563 C0.5,6.37005443 0.95018776,7.48551872 1.76040116,8.35991746 L7.609819,15.1162593 C7.63588257,15.1498787 7.6608115,15.1787446 7.68284916,15.2011824 C7.87441495,15.3934335 8.1244312,15.5 8.39413841,15.5 C8.66292177,15.5 8.91335152,15.3940512 9.08949156,15.2177292 C9.13138797,15.1735418 9.14959901,15.1534179 9.17885461,15.1185233 L15.256921,8.34890727 C16.0511659,7.48458011 16.5,6.36808352 16.5,5.18420563 Z"></path>
                            </g>
                        </svg>
                        <p v-if="commentLikes == 1">{{ commentLikes }} Like</p>
                        <p v-else-if="commentLikes > 1">{{ commentLikes }} Likes</p>
                        <p v-else>Like</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showReplyBox">
            <comment-box :parent-id="reply.comment_id"></comment-box>
        </div>
        <deep-replies
            v-for="deepReply in reply.replies"
            :key="deepReply.comment_id"
            :reply="deepReply"
            :first_username="deepReply.user_name"
            :depth="currentDepth"
        ></deep-replies>
    </div>
</template>

<script>
import CommentBox from "./CommentBox";

export default {
    name: 'deepReplies',
    components: {
        CommentBox
    },
    props: {
        reply: Object,
        first_username: String,
        depth: Number
    },
    data() {
        return {
            userLiked: this.reply.user_liked,
            commentLikes: parseInt(this.reply.comment_likes),
            parent_username: this.reply.user_name,
            showReplyBox: false,
            currentDepth: this.depth + 1
        }
    },
    mounted() {
        //console.log('reply', this.reply);
    },
    methods: {
        saveCommentLike(commentId) {
            let commentData = {
                commentId: commentId,
                communityId: this.$root.community.id
            };
            this.$http.post('/post/like-comment', commentData)
                .then(response => {
                    if (response.data.community_id === false) {
                        let modalData = {
                            cta: false,
                            message: 'You are currently not a member of this community - please join the community to like this comment',
                            communityName: this.$root.community.name,
                            communityThumbnail: this.$root.community.thumbnail,
                            title: 'Join ' + this.$root.community.name
                        };
                        this.$root.$emit('show-community-modal', modalData);
                    } else if (response.data.liked === true) {
                        this.commentLikes++;
                        this.userLiked = true;
                    } else if (response.data.liked === false) {
                        this.commentLikes--;
                        this.userLiked = false;
                    }
                }, response => {
                    console.log('Errored:');
                    console.log(response);
                });
        },
        commentReply() {
            this.showReplyBox = true;
        }
    }
}
</script>
